import React from 'react';
import { FC } from 'react';

export const ColorPickerEmpty: FC<{}> = () => (
    <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_25_6)'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M23.6799 22.3841L-0.320099 2.38411L0.320086 1.61589L24.3201 21.6159L23.6799 22.3841Z'
                fill='#DE1C22'
            />
        </g>
        <defs>
            <clipPath id='clip0_25_6'>
                <rect width='24' height='24' />
            </clipPath>
        </defs>
    </svg>
);
